module.exports = __webpack_public_path__ + "img/calendar.c3da6bbb.svg";